import React from "react";
import ScheduleGarrisonUtils from "../utils/schedulegarrison-utils.jsx";

const HourContent = ({ type, hours, isUpdate = false }) => {
    if (!hours) return null;

    const current = hours.new ?? hours;
    const previous = hours.old ?? {};

    return (
        <>
            <ScheduleGarrisonUtils.Row
                isUpdate={isUpdate}
                label={`${type !== "FIXED" ? "Horário inicial" : "Horário"}`}
                value={!isUpdate ? current.startHour : undefined}
                newValue={ScheduleGarrisonUtils.getNew(current.startHour) ?? current.startHour}
                oldValue={ScheduleGarrisonUtils.getOld(current.startHour) ?? previous.startHour}
            />

            { type !== "WITHOUT_HOUR" && (
                <ScheduleGarrisonUtils.Row
                    isUpdate={isUpdate}
                    label="Dia seguinte"
                    value={!isUpdate ? current.startChangeDay : undefined}
                    newValue={ScheduleGarrisonUtils.getNew(current.startChangeDay) ?? current.startChangeDay}
                    oldValue={ScheduleGarrisonUtils.getOld(current.startChangeDay) ?? previous.startChangeDay}
                />
            )}

            { type !== "FIXED" && (
                <ScheduleGarrisonUtils.Row
                    isUpdate={isUpdate}
                    label="Horário final"
                    value={!isUpdate ? current.endHour : undefined}
                    newValue={ScheduleGarrisonUtils.getNew(current.endHour) ?? current.endHour}
                    oldValue={ScheduleGarrisonUtils.getOld(current.endHour) ?? previous.endHour}
                />
            )}

            { type !== "WITHOUT_HOUR" && (ScheduleGarrisonUtils.getNew(current.endHour) ?? current.endHour) && (
                <ScheduleGarrisonUtils.Row
                    isUpdate={isUpdate}
                    label="Dia seguinte"
                    value={!isUpdate ? current.endChangeDay : undefined}
                    newValue={ScheduleGarrisonUtils.getNew(current.endChangeDay) ?? current.endChangeDay}
                    oldValue={ScheduleGarrisonUtils.getOld(current.endChangeDay) ?? previous.endChangeDay}
                />
            )}

            { type !== "FIXED" && (
                <ScheduleGarrisonUtils.Row
                    isUpdate={isUpdate}
                    label="Permite repetição"
                    value={!isUpdate ? current.allowRepeat : undefined}
                    newValue={ScheduleGarrisonUtils.getNew(current.allowRepeat) ?? current.allowRepeat}
                    oldValue={ScheduleGarrisonUtils.getOld(current.allowRepeat) ?? previous.allowRepeat}
                />
            )}
        </>
    );
};

export default HourContent;